import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  width: 100vw;
  min-height: 50vh;
`;

const StyledTechStack = styled.h1`
  position: relative;
  width: 100%;
  padding: 0 1rem;
  margin-top: 3rem;
  margin-bottom: 1.5rem;
  overflow: hidden;
  &:before {
    content: "";
    position: absolute;
    top: -10px;
    left: -2px;
    bottom: -10px;
    width: 5px;
    height: 150%;
    background-color: #60a5fa;
  }
`;

const Skills = () => {
  const technologies = [
    {
      id: 1,
      name: "HTML 5",
      technology: "html.svg",
    },
    {
      id: 2,
      name: "CSS 3",
      technology: "css.svg",
    },
    {
      id: 3,
      name: "Javascript",
      technology: "javascript.svg",
    },
    {
      id: 4,
      name: "Tailwind",
      technology: "tailwind.svg",
    },
    {
      id: 5,
      name: "React JS",
      technology: "react.svg",
    },
    {
      id: 6,
      name: "Next JS",
      technology: "next.svg",
    },
    {
      id: 7,
      name: "Redux",
      technology: "redux.svg",
    },
    {
      id: 8,
      name: "Typescript",
      technology: "typescript.svg",
    },
    {
      id: 9,
      name: "Styled Components",
      technology: "styled.svg",
    },
    {
      id: 10,
      name: "Node JS",
      technology: "nodeJS.svg",
    },
    {
      id: 11,
      name: "Express JS",
      technology: "express.svg",
    },
    {
      id: 12,
      name: "Mongo DB",
      technology: "mongoDB.svg",
    },
    {
      id: 13,
      name: "MySQL",
      technology: "mySQL.svg",
    },
    {
      id: 14,
      name: "Firebase",
      technology: "firebase.svg",
    },
    {
      id: 15,
      name: "Git",
      technology: "git.svg",
    },
  ];

  // const backEnd = [
  //   {
  //     id: 10,
  //     name: "Node JS",
  //     technology: "nodeJS.svg",
  //   },
  //   {
  //     id: 11,
  //     name: "Express JS",
  //     technology: "express.svg",
  //   },
  //   {
  //     id: 12,
  //     name: "Mongo DB",
  //     technology: "mongoDB.svg",
  //   },
  //   {
  //     id: 13,
  //     name: "MySQL",
  //     technology: "mySQL.svg",
  //   },
  //   {
  //     id: 14,
  //     name: "Firebase",
  //     technology: "firebase.svg",
  //   },
  // ];

  return (
    <StyledDiv className="px-5 pt-10 pb-5 flex flex-col sm:px-10 ">
      <div className="mt-5">
        <StyledTechStack className="font-rubik text-2xl font-bold lg:text-3xl">
          Tech Stack
        </StyledTechStack>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 lg:w-4/5  lg:gap-y-6 mx-auto">
          {technologies.map((technology) => (
            <div
              key={technology.id}
              className="flex-col rounded-lg bg-transparent flex py-5 px-5 my-2 justify-center items-center hover:shadow-md hover:bg-white mx-auto"
            >
              <img
                alt={`${technology.technology}`}
                className="h-20"
                src={`./images/svg/${technology.technology}`}
              />
              <p className="mt-5 w-28 py-1 border text-center font-karla text-sm">
                {technology.name}
              </p>
            </div>
          ))}
        </div>
        {/* <StyledTechStack className="font-rubik text-2xl font-bold lg:text-3xl">
          Back End
        </StyledTechStack>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:w-3/5  lg:gap-y-6 mx-auto">
          {backEnd.map((technology) => (
            <div
              key={technology.id}
              className="flex-col rounded-lg bg-transparent  flex py-5 px-5 mx-auto my-2 justify-center items-center hover:shadow-md hover:bg-white"
            >
              <img
                alt={`${technology.technology}`}
                className="h-40"
                src={`./images/svg/${technology.technology}`}
              />
              <p className="mt-5 w-28 py-1 border text-center font-karla text-sm">
                {technology.name}
              </p>
            </div>
          ))}
        </div> */}
      </div>
    </StyledDiv>
  );
};

export default Skills;
